import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';

const ProfileSkeleton = () => (
  <div className="flex flex-col justify-between gap-8 min-h-screen min-w-screen">
    <Card className="flex flex-col gap-8 w-full h-full border-none shadow-none lg:p-8 lg:border-solid lg:border-border lg:rounded-lg lg:drop-shadow-sm">
      <Skeleton className="h-8 w-[300px]" />
      <Skeleton className="flex flex-col border-border rounded-lg shadow-none">
        <div
          className={
            'flex flex-col justify-between gap-4 p-4 rounded-t-lg lg:flex-row lg:gap-16 lg:gap-6 lg:p-6'
          }
        >
          <div className="flex items-center gap-4">
            <Skeleton className={'size-20 rounded-full bg-primary/10'} />
            <div className={'flex flex-col justify-center gap-3'}>
              <Skeleton className="h-[28px] w-[200px] bg-primary/10" />
              <div className="flex flex-col gap-2 sm:flex-row sm:gap-6">
                <Skeleton className="h-6 w-[150px] bg-primary/10" />
                <Skeleton className="h-6 w-[60px] bg-primary/10 md:w-[120px]" />
              </div>
            </div>
          </div>
          <div className="flex gap-3 items-center md:gap-6">
            <Skeleton className="h-6 w-[80px] md:w-[120px]" />
            <Skeleton className="h-6 w-[80px] md:w-[120px]" />
            <Skeleton className="h-6 w-[80px] md:w-[120px]" />
          </div>
        </div>
        <div className="flex flex-col gap-3 p-6 md:flex-row md:gap-0">
          <div className="w-full md:pr-6">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-[160px]" />
              <div className="flex flex-col gap-3 p-3 bg-gray-50 rounded-lg border border-border">
                <div className="flex gap-2 items-center">
                  <Skeleton className="h-5 w-[100px]" />
                </div>
                <div className="flex gap-2 items-center">
                  <Skeleton className="h-5 w-[120px]" />
                </div>
                <div className="flex gap-2 items-start">
                  <Skeleton className="h-5 w-[90px]" />
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:pl-6 md:border-l-2 md:border-border">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-4 w-[160px]" />
              <div className="flex flex-col gap-3 p-3 bg-gray-50 rounded-lg border border-border">
                <div className="flex gap-2 items-center">
                  <Skeleton className="h-5 w-[100px]" />
                </div>
                <div className="flex gap-2 items-center">
                  <Skeleton className="h-5 w-[120px]" />
                </div>
                <div className="flex gap-2 items-start">
                  <Skeleton className="h-5 w-[90px]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Skeleton>
      <Separator />
      <div className="flex flex-col gap-6">
        <div className="flex">
          <div className="w-full">
            <div className="space-y-2 relative w-full">
              <Skeleton className="h-3 w-[100px]" />
              <Skeleton className="h-10 w-full max-w-[400px]" />
            </div>
          </div>
          <div className="w-full">
            <div className="space-y-2 relative w-full">
              <Skeleton className="h-3 w-[100px]" />
              <Skeleton className="h-10 w-full max-w-[400px]" />
            </div>
          </div>
        </div>
        <div className="flex items-end gap-4">
          <div className="relative space-y-1.5 w-fit">
            <Skeleton className="h-3 w-[100px]" />
            <Skeleton className="h-10 w-full max-w-[400px]" />
          </div>
        </div>
        <div className="relative w-full space-y-1.5">
          <Skeleton className="h-3 w-[100px]" />
          <Skeleton className="h-10 w-full max-w-[400px]" />
        </div>
      </div>
    </Card>
    <div className="sticky bottom-0 left-0 flex justify-end items-center w-full p-2 bg-background">
      <Skeleton className="h-[46px] w-[190px]" />
    </div>
  </div>
);

export { ProfileSkeleton };
